<template>
  <div class="regenere-result-page flex flex-col items-center">
    <svg
      class="regenere-check"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      fill="none"
    >
      <circle
        cx="48"
        cy="48"
        r="44"
        stroke="#CDAA4C"
        stroke-width="4"
      />
      <path
        d="M30 49.5 L43 62 L66 37"
        stroke="#CDAA4C"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>
    <div class="regenere-eyebrow">FORMULA CONFIRMED</div>
    <h1 class="regenere-heading">
      <span class="regenere-heading-text">Your previous formula is on its way.</span>
    </h1>
    <div class="regenere-body">
      <p>We are preparing the same formula from your last order — no reassessment needed.</p>
      <p>Our lab team will review your file and begin production within 1–2 business days.</p>
      <p class="regenere-contact">
        If you'd like to update your formula instead, please
        <a
          href="https://www.regenere.com/pages/contact"
          target="_blank"
          rel="noopener"
          >contact us</a
        >.
      </p>
    </div>
    <a
      class="regenere-button"
      href="https://www.regenere.com/"
    >
      Back to Homepage
    </a>
  </div>
</template>

<script>
export default {
  name: "RegenereSuccessPage",
};
</script>

<style scoped>
.regenere-result-page {
  background-color: #f5f1e7;
  min-height: calc(100vh - 44px);
  width: 100%;
  flex: 1 1 auto;
  padding: 80px 20px 60px;
  text-align: center;
}

.regenere-check {
  width: 96px;
  height: 96px;
}

.regenere-eyebrow {
  margin-top: 18px;
  font-family: "DM Sans", sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.08em;
  color: #000;
  text-transform: uppercase;
}

.regenere-heading {
  margin-top: 36px;
  font-family: "Cormorant Garamond", "Playfair Display", "Times New Roman", serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 1.15;
  max-width: 820px;
}

.regenere-heading-text {
  display: inline-block;
  background: linear-gradient(90deg, #000 0%, #000 30%, #e3a52a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.regenere-body {
  margin-top: 28px;
  font-family: "DM Sans", sans-serif;
  font-size: 16px;
  line-height: 1.3;
  color: #1a1a1a;
  max-width: 820px;
}

.regenere-body p {
  margin: 0;
}

.regenere-contact {
  margin-top: 18px !important;
}

.regenere-contact a {
  color: #1a1a1a;
  text-decoration: underline;
}

.regenere-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 36px;
  width: 280px;
  padding: 18px 24px;
  background-color: #cdaa4c;
  color: #fff;
  border-radius: 5px;
  font-family: "DM Sans", sans-serif;
  font-size: 16px;
  line-height:16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  text-decoration: none;
}

.regenere-button:hover {
  background-color: #b69239;
}

@media (min-width: 768px) {
  .regenere-result-page {
    min-height: calc(100vh - 76px);
    padding: 120px 40px 80px;
  }
  .regenere-heading {
    margin-top: 36px;
    font-size: 48px;
    letter-spacing: 0.02em;
  }
  .regenere-body {
    margin-top: 32px;
    font-size: 20px;
  }
  .regenere-button {
    width: 320px;
    padding: 21px 24px;
    font-size: 18px;
    line-height:18px;
  }
}
</style>
